import React, { FunctionComponent } from 'react';
import MuiAppBar, { AppBarProps as MuiProps } from '@material-ui/core/AppBar';
import useStyles from './style';
import clsx from 'clsx';

type VariantType = 'bottom' | 'top';

export interface AppBarProps extends Omit<MuiProps, 'variant'> {
    variant?: VariantType;
}

const AppBar: FunctionComponent<AppBarProps> = (props: AppBarProps) => {
    const classes = useStyles();
    const { className, variant, ...other } = props;
    const classNameMerged = clsx(
        {
            [classes.variantTop]: variant === 'top',
            [classes.variantBottom]: variant === 'bottom',
        },
        className,
    );

    return <MuiAppBar className={classNameMerged} {...other} />;
};

export default AppBar;
